<template>

  <div class="dialog-cover">

    <div class="poster-dialog-main">

      <img :src="posterImgUrl" class="poster-dialog-img" />

      <div class="close" style="color: white; text-align: center" @click="closeDialog">
        <p>长按即可保存海报</p>
        <img src="https://static.21jingji.com/images/m/icon_closed.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>

import { computed } from 'vue';

export default {
  name: "PosterDialog",
  props: {
    imgUrl: {
      type: String
    },
    closeDialog: {
      type: Function
    }
  },
  setup(props) {

    const posterImgUrl = computed(() => props.imgUrl);

    return {
      posterImgUrl
    };
  }
}
</script>

<style lang="less" scoped>
.poster-dialog-main {
  background-color: transparent;
  width: calc(1080px / 3.5);
  position: fixed;
  left: calc((100% - 1080px / 3.5) / 2);
  top: 7%;
  height: 50rem;
  text-align: center;
}

.poster-dialog-img {
  width: calc(2553px / 9);
  height: calc(4536px / 9);
  border: 1px solid #036ec3;
}

.close {
  margin-top: 4px;
  font-size: 12px;

  img {
    margin-top: 8px;
    width: 32px;
    height: 32px
  }
}
</style>